// extracted by mini-css-extract-plugin
module.exports = {"container":"_3_ruaZOz5e13 _1avof0TUTr00"};